import { formatDateLongMonthWithMeridiemNoSeconds as formatDate } from '~/services/TimeService';

import type { ScheduleHistoryDiffField, ScheduleHistorySchedule } from './campaignScheduleHistoryDiff';

const SCHEDULE_TYPE_LABELS: Record<string, string> = {
  availability: 'Purchase',
  online_purchase: 'Online Purchase',
  list_visibility: 'List Visibility',
  lux_plus: 'LuxPlus',
};

const ACTION_LABELS: Record<string, string> = {
  INSERT: 'Created',
  UPDATE: 'Updated',
  DELETE: 'Deleted',
};

const DATE_DIFF_FIELDS = new Set(['start', 'end']);

const DIFF_FIELD_LABELS: Record<string, string> = {
  start: 'Start',
  end: 'End',
  marketing_channels: 'Marketing channels',
};

export function getScheduleTypeLabel(type: string): string {
  return SCHEDULE_TYPE_LABELS[type] ?? type;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function getScheduleLabel(schedule: ScheduleHistorySchedule): string {
  return `${getScheduleTypeLabel(schedule.type)} · ${schedule.region} · ${schedule.brand}`;
}

export function formatDiffValue(diff: ScheduleHistoryDiffField, value: string | null): string {
  if (!value) {
    return '—';
  }

  return DATE_DIFF_FIELDS.has(diff.field) ? formatDate(value) : value;
}

export function getDiffFieldLabel(field: string): string {
  return DIFF_FIELD_LABELS[field] ?? field;
}
